import React, { useContext, useState } from "react";
import { Button, Card, Col, Jumbotron, Row } from "react-bootstrap";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";
import ContextContainer from "../../Context";
import Statics from "../../Statics";
import "./LastPosts.css";

const LastPosts = () => {
  const context = useContext(ContextContainer);

  const [loading, set_loading] = useState(Statics.NOT_LOADED);
  const [posts, set_posts] = useState([]);

  const loadPosts = () => {
    set_loading(Statics.LOADING);
    const storedPosts = sessionStorage.getItem("allHomePosts");
    if (storedPosts) {
      const parsedPosts = JSON.parse(storedPosts);
      set_posts(parsedPosts);
      set_loading(Statics.LOADED);
    } else {
      context.ApiDriver.getPosts(
        { page_size: 3 },
        data => {
          set_loading(Statics.LOADED);
          set_posts(data);
          sessionStorage.setItem("allHomePosts", JSON.stringify(data));
        },
        error => {
          console.log(error);
          set_loading(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  if (loading === Statics.NOT_LOADED) {
    loadPosts();
  }

  return (
    <Jumbotron className="py-1"  style={{ background: "#fff" , maxWidth:"1300px" , margin: "auto"}}>
      <Row style={{ direction: "rtl" }}>
        {loading === Statics.NOT_LOADED || loading === Statics.LOADING
          ? "در حال بارگذاری"
          : ""}
        {loading === Statics.LOADED
          ? posts.map(post => (
              <Col key={post.id} md={4} sm={12} className="last-post-col pt-3 pb-3">
                <Card className="weblog">
                  <Link to={`/blog/post/${post.id}`}>
                    <Card.Img
                      variant="top"
                      src={post.cover_pic_urls.lg}
                      className="last-post-cover"
                    />
                  </Link>
                  <Card.Body className="card-body1">
                    <Card.Title className="card-title1">
                      {post.title}
                    </Card.Title>
                    <Card.Text className="lastpost-text outbox-content outbox-content2">
                      {renderHTML(post.summary)}
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer className="d-flex justify-content-center">
                    <Link to={`/blog/post/${post.id}`}>
                      <Button variant="legendary">مشاهده مقاله</Button>
                    </Link>
                  </Card.Footer>
                </Card>
              </Col>
            ))
          : ""}
      </Row>
    </Jumbotron>
  );
};

export default LastPosts;
